const STRIP_HEIGHT = 100;

export const VISIBLE_AREA_CHANGE_EVENT = "visible-area-change";
const THRESHOLDS = Array.from({ length: 21 }, (_, i) => i / 20);

export const trackIframeVisibleArea = () => {
  const layer = document.createElement("div");
  layer.setAttribute("aria-hidden", "true");
  layer.style.cssText =
    "position:fixed;top:0;left:0;width:1px;height:100%;opacity:0;pointer-events:none;z-index:-1";
  document.body.appendChild(layer);

  const visibleStrips = new Map<Element, DOMRectReadOnly>();

  const applyVisibleArea = () => {
    if (visibleStrips.size === 0) return;
    let top = Infinity;
    let bottom = -Infinity;
    visibleStrips.forEach((rect) => {
      top = Math.min(top, rect.top);
      bottom = Math.max(bottom, rect.bottom);
    });
    const root = document.documentElement.style;
    root.setProperty("--visible-top", `${Math.round(top)}px`);
    root.setProperty("--visible-height", `${Math.round(bottom - top)}px`);
    window.dispatchEvent(
      new CustomEvent(VISIBLE_AREA_CHANGE_EVENT, { detail: { top: Math.round(top) } })
    );
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visibleStrips.set(entry.target, entry.intersectionRect);
        else visibleStrips.delete(entry.target);
      });
      applyVisibleArea();
    },
    { threshold: THRESHOLDS }
  );

  const buildStrips = () => {
    observer.disconnect();
    visibleStrips.clear();
    layer.replaceChildren();
    const count = Math.ceil(window.innerHeight / STRIP_HEIGHT);
    for (let i = 0; i < count; i++) {
      const strip = document.createElement("div");
      strip.style.cssText = `position:absolute;left:0;width:1px;top:${i * STRIP_HEIGHT}px;height:${STRIP_HEIGHT}px`;
      layer.appendChild(strip);
      observer.observe(strip);
    }
  };

  buildStrips();
  window.addEventListener("resize", buildStrips);

  return () => {
    window.removeEventListener("resize", buildStrips);
    observer.disconnect();
    layer.remove();
  };
};
